import React, { useRef } from 'react';
import Section, { size } from '../../generic/Section';
import { mergeClassNames, useInViewport, useAtTopOfViewport } from '../../../utils';
import Image from '../../generic/Image';
import SVGIcon from '../../generic/SVGIcon';
import RichText from '../../generic/RichText';
import styles from './index.module.scss';

export default function FeaturesParallax({ features, heading }) {
  let bottomRef = useRef(null);
  let isAtBottom = useInViewport(bottomRef);
  let intersectionRef = useRef(null);
  let isCovering = useAtTopOfViewport(intersectionRef);

  return (
    <Section
      elementRef={intersectionRef}
      className={mergeClassNames(
        styles.features,
        // styles.debug,
        isCovering ? styles.isCovering : '',
        isAtBottom ? styles.isAtBottom : ''
      )}
      size={size.full}
    >
      {features.map((feature, index) => (
        <Feature feature={feature} index={index} heading={heading} key={index} />
      ))}
      <div ref={bottomRef} className={styles.bottomRef} />
    </Section>
  );
}

function Feature({ feature, index, heading = '' }) {
  let ref = useRef(null);
  let inView = useInViewport(ref, false);

  return (
    <div className={styles.feature} key={index}>
      <div className={styles.imageContainer}>
        <Image className={mergeClassNames(styles.image, inView ? styles.inView : null)} fluid={feature.image?.fluid} />
      </div>

      <div className={styles.page}>
        <div ref={ref} className={mergeClassNames(styles.box, styles[feature.position || 'Center'])}>
          {/* <Image fluid={feature.image?.fluid} /> */}
          {heading && <h4 className={styles.featureHeading}>{heading}</h4>}
          <h3>{feature.heading}</h3>
          <div className={styles.content}>
            <SVGIcon svgIcon={feature.icon} className={styles.icon} />
            <RichText className={styles.text}>{feature.description?.description}</RichText>
          </div>
        </div>
      </div>
    </div>
  );
}
